export default function throttle (type, name, obj){
  obj = obj || window;
  let running = false;
  const func = () => {
    if (running){ return; }
    running = true;
    requestAnimationFrame(function(){
      const event =  document.createEvent('Event');
      event.initEvent(name, true, true);
      obj.dispatchEvent(event);
      running = false;
    });
  };
  obj.addEventListener(type, func);
}



// WEBPACK FOOTER //
// ./scripts/util/raf-throttle.js